module.exports = __webpack_public_path__ + "img/amazon.0a392b0d.jpg";